import React, { useContext, useEffect, useState } from 'react'
import Footer from '../../Components/Footer'
import Header from '../../Components/Header'
import RadioButtonChecked from '@mui/icons-material/RadioButtonChecked';
import Chapa from '../../assets/chapa-logo.png'
import Thumb from '../../assets/thumb.jpg'
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../../api';
import { baseUrl, path } from '../../constants';
import { Oval } from 'react-loader-spinner'
import { settingsContext } from '../../Context/settingsProvider';

export default function Checkout() {
    const {id} = useParams()
    const [loading, setLoading ] = useState(true)
    const navigate = useNavigate()
    const [course, setCourse] = useState({})
    const [initializing, setInitializing] = useState(false)
    const {t} = useContext(settingsContext)

    useEffect(() => {
        api.get(path.getCourseDetail + '/' + id).then(response => {
            let data = response.data
            if(!data.success) return navigate('/')
            setCourse(data.course)
            setLoading(false)
        })
    }, [])

    const initializePayment = () => {
        setInitializing(true)
        api.post(path.initializePayment, {id}).then(response => {
            let data = response.data
            if(data.success){
                if(course.isFree) navigate('/learn/' + course.id + '?payment=true')
                else window.location.href = data.paymentLink
                // setInitializing(false)
            }
        }).finally(() => setInitializing(false))
    }

    return (
        <div className='w-full h-screen flex flex-col pt-[60px] overflow-x-hidden'>
        <Header withLogo />
        <div className='flex-1 flex max-md:flex-col'>
            <div className='flex-1 flex flex-col p-12 gap-5'>
                <h1 className='text-black text-[25px] font-bold'>{t('CHECKOUT')}</h1>
                {!course.isFree && [
                <p>{t('CHOOSE_PAYMENT')}</p>,
                <h1 className='text-black text-[22px] font-bold'>{t('PAYMENT_METHOD')}</h1>,
                <div className='flex flex-col gap-3'>
                    <div className='flex items-center gap-3 bg-lightGrey p-5 max-md:p-3 shadow-md rounded-md'>
                        <RadioButtonChecked style={{color: '#000000', fontSize: 16}}>Filled</RadioButtonChecked>
                        <div className='p-1 border-[1px] border-[#00000050] border-solid bg-white flex items-center justify-center'>
                            <img className='w-[50px] h-[50px] object-contain' src={Chapa} alt='telebirr logo' />
                        </div>
                        <p className='text-[16px] text-black font-bold'>Chapa</p>
                    </div>
                </div>
                ]}
                <div className='flex flex-col gap-3 w-full mt-3'>
                    <h2 className='text-black text-[22px] font-bold'>{t('ORDER_DETAILS')}</h2>
                    {loading ? (
                         <Oval
                            visible={true}
                            height="30"
                            width="30"
                            color="#000000"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                         /> ) : (
                            <div className='flex items-center justify-between w-full'>
                                <div className='flex items-center gap-2'>
                                    <img className='w-[80px] h-80px object-contain rounded-md' src={baseUrl + course.thumbnail} alt='thumbnail' />
                                    <p className='text-[16px] text-black font-bold'>{course.title}</p>
                                </div>
                                <p className='text-black text-[14px]'>{t('ETB')} {course.price}</p>
                            </div>
                         )}
                </div>
            </div>
            <div className='flex-1 flex flex-col bg-lightGrey gap-5 p-12'>
                <h2 className='text-black text-[20px]'>{t('SUMMARY')}</h2>
                <div className='flex flex-col w-[50%] gap-2'>
                    {loading ? (
                         <Oval
                            visible={true}
                            height="30"
                            width="30"
                            color="#000000"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                         /> ) : (
                            <div className='flex w-[100%] justify-between items-center'>
                                <p className='text-black text-[14px]'>{t('SUBTOTAL')}:</p>
                                <p className='text-black text-[14px]'>{t('ETB')} {course.price}</p>
                            </div>
                         )}
                    
                    {/* <div className='flex w-[100%] justify-between items-center'>
                        <p className='text-black text-[14px]'>Discount:</p>
                        <p className='text-black text-[14px]'>- ETB 0</p>
                    </div> */}
                </div>
                
                <hr className='w-[50%] text-[#00000050]' />
                <div className='flex w-[50%] justify-between items-center'>
                    <p className='text-black text-[18px] font-bold'>{t('TOTAL')}:</p>
                    <p className='text-black text-[18px] font-bold'>{t('ETB')} {course.price}</p>
                </div>
                {/* <p className='text-[13px] text-black'>Copy the Transaction Number and type it here.</p> */}
                {/* <input placeholder='Transaction Number' type='text' className='text-black border-[1px] border-black w-[50%] p-2 pl-4 uppercase'  /> */}
                {/* <input placeholder='Your Phone Number' type='text' className='text-black border-[1px] border-black w-[50%] p-2 pl-4 uppercase'  /> */}
                <button onClick={initializePayment} className='bg-main w-[50%] text-white flex justify-center    text-[20px] p-2 text-center'>
                    {initializing ? (
                        <Oval
                            visible={true}
                            height="30"
                            width="30"
                            color="#ffffff"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                        />
                    ) : course.isFree ? 'Purchase for Free' : t('PAY_NOW')}
                </button>
            </div>
        </div>
        <Footer />
        </div>
    )
}